export default __webpack_public_path__ + "static/media/sideImage_1.e5f3cc7c.svg";